module.exports = __webpack_public_path__ + "static/img/air1 (3).08b7de14.jpg";